export const compareColors = ['F5A846', '7AC48E', '6AC3ED'];
